/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PidSimulationValidationResponse
 */
export interface PidSimulationValidationResponse {
    /**
     * 
     * @type {string}
     * @memberof PidSimulationValidationResponse
     */
    gpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PidSimulationValidationResponse
     */
    xmlRequest?: string;
}

/**
 * Check if a given object implements the PidSimulationValidationResponse interface.
 */
export function instanceOfPidSimulationValidationResponse(value: object): value is PidSimulationValidationResponse {
    return true;
}

export function PidSimulationValidationResponseFromJSON(json: any): PidSimulationValidationResponse {
    return PidSimulationValidationResponseFromJSONTyped(json, false);
}

export function PidSimulationValidationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PidSimulationValidationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gpCode': json['gpCode'] == null ? undefined : json['gpCode'],
        'xmlRequest': json['xmlRequest'] == null ? undefined : json['xmlRequest'],
    };
}

export function PidSimulationValidationResponseToJSON(json: any): PidSimulationValidationResponse {
    return PidSimulationValidationResponseToJSONTyped(json, false);
}

export function PidSimulationValidationResponseToJSONTyped(value?: PidSimulationValidationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gpCode': value['gpCode'],
        'xmlRequest': value['xmlRequest'],
    };
}

